<div class="activity-card-root" [ngClass]="{'coupon-vip': isCouponVip}">
  <div class="header">
    <div class="account-information">
      <app-rounded-image [src]="picture" xxsmall></app-rounded-image>
      <div class="text-area">
        <app-label class="name" id="business-name-activity-card" isBig (click)="openCustomerDetailPage()" matTooltip="{{headerTitle}}" matTooltipPosition="above" matTooltipClass="name-tooltip" matTooltipDisabled="{{maxNameLength(headerTitle)}}">{{headerTitle}}</app-label>
      </div>
    </div>
    <div class="button-area">
      <div class="note-info" *ngIf="note && !isCouponVip"></div>
      <app-icon-click *ngIf="!isCouponVip" id="notes-info-popup" flat (click)="toggleNotes()">comment</app-icon-click>
      <app-icon-click id="business-info-click" (click)="toggleInfo()" flat>info_outline</app-icon-click>
    </div>
  </div>
  <div class="popup-preamble">
    <app-business-info-popup [ngClass]="{'visible': showInfo}"
                             [activePoints]="businessPointsInfo?.activePoints"
                             [pointsAddedThisMonth]="businessPointsInfo?.pointsAddedThisMonth"
                             [pointsExpiringThisMonth]="businessPointsInfo?.pointsExpiringThisMonth"
                             [nextPointsExpiring]="businessPointsInfo?.nextPointsExpiring"
                             [nextPointsExpiringDate]="businessPointsInfo?.nextPointsExpiringDate"
                             [pointsExpiredLastYear]="businessPointsInfo?.pointsExpiredLastYear"
                             [pointsExpiringThisYear]="businessPointsInfo?.pointsExpiringOnThisYear"
                             [pointsExpiringNextYear]="businessPointsInfo?.pointsExpiringOnNextYear"
                             [pointsRedeemedThisMonth]="businessPointsInfo?.pointsRedeemedThisMonth"
                             [familyName]="businessPointsInfo?.familyName"
                             [registersOnVIPWindow]="businessPointsInfo?.registersOnVIPWindow"
                             [state]="businessPointsInfo?.state"
                             [country]="'fi fi-'+businessPointsInfo?.country?.initials.toLowerCase()"
                             (closeClick)="closeInfo()">
    </app-business-info-popup>
    <app-notes-info-popup (closeClick)="closeNotes()"
                          (saveClick)="saveNote($event)"
                          [ngClass]="{'visible': showNotes}"
                          [note]="note"
                          [viewOnly]="viewOnly"
                          [canSave]="true">
    </app-notes-info-popup>
  </div>
  <app-horizontal-separator></app-horizontal-separator>
  <div class="content">
    <ng-content></ng-content>
  </div>
  <app-horizontal-separator></app-horizontal-separator>
  <div class="footer">
    <app-chip small 
      *ngIf="!timelineDisabled"
      id="expiration-chip" defaultCursor small filled 
      [darkBlue]="isRedeemed" [red]="isCanceled" [gray]="isExpired" [green]="isActive" [orange]="isSuspended">
      {{statusCheck[0] | transloco: { day: (calculateDaysToExpiration())} }} {{statusCheck[1] | date : 'd MMM y' : '' : getLanguege()}}
    </app-chip>
    <div *ngIf="timelineDisabled">
      This business coupon timeline is disabled
    </div>
  </div>
</div>
